import * as Cmp from "@impero-com/common/utils/comparison";

import { Tag, TagCategory } from "../types";

import { TagAndCategory } from "./tagAndCategory";
import { TagAndCategoryListContainer } from "./tagAndCategoryListContainer";

export interface TagAndCategoryListProps {
    tags: Tag[];
    tagCategories: TagCategory[];
}

export function TagAndCategoryList({
    tags,
    tagCategories,
}: TagAndCategoryListProps) {
    const stringCompare = Cmp.string();

    const tagsWithCategories = tags
        .map((tag) => {
            const category = tagCategories.find(
                (cat) => cat.id === tag.tagCategoryId
            );
            if (!category) {
                throw new Error(
                    `TagCategory(id=${tag.tagCategoryId}) not found for Tag(id=${tag.id})`
                );
            }
            return {
                id: tag.id,
                tagName: tag.name,
                categoryName: category.name,
            };
        })
        .toSorted(
            Cmp.chain([
                Cmp.map((t) => t.categoryName, stringCompare),
                Cmp.map((t) => t.tagName, stringCompare),
            ])
        );

    return (
        <TagAndCategoryListContainer>
            {tagsWithCategories.map(({ id, categoryName, tagName }) => (
                <TagAndCategory
                    key={id}
                    categoryName={categoryName}
                    tagName={tagName}
                />
            ))}
        </TagAndCategoryListContainer>
    );
}
